import type { Template } from "@/types";

export const LA_07_H0_V7: Template[] = [
{
    id: "la-07-h0v7-01",
    name: "LA 01 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 111, y: 51, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "2", x: 111, y: 241, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 252, y: 51, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 252, y: 241, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 392, y: 51, width: 134, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 392, y: 241, width: 134, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 823, y: 51, width: 277, height: 374, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-02",
    name: "LA 02 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 135, y: 0, width: 368, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 748, y: 51, width: 134, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 890, y: 51, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1030, y: 51, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 748, y: 241, width: 134, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 890, y: 241, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1030, y: 241, width: 133, height: 183, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-03",
    name: "LA 03 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 110, y: 33, width: 275, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 393, y: 33, width: 134, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 393, y: 241, width: 134, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 802, y: 33, width: 150, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 802, y: 241, width: 150, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 33, width: 150, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 959, y: 241, width: 150, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-04",
    name: "LA 04 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 167, y: 33, width: 149, height: 202, rotation: 0, imageRotation: 0 },
            { id: "2", x: 167, y: 242, width: 149, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 33, width: 148, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 242, width: 148, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 747, y: 33, width: 275, height: 409, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1030, y: 33, width: 134, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1030, y: 241, width: 134, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-05",
    name: "LA 05 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 130, y: 49, width: 250, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 386, y: 49, width: 122, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 386, y: 241, width: 122, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 49, width: 260, height: 376, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1041, y: 49, width: 96, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1041, y: 177, width: 96, height: 120, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1041, y: 306, width: 96, height: 120, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-06",
    name: "LA 06 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 135, y: 52, width: 245, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 387, y: 240, width: 118, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 387, y: 52, width: 118, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 801, y: 37, width: 151, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 801, y: 245, width: 151, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 37, width: 151, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 959, y: 245, width: 151, height: 200, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-07",
    name: "LA 07 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 108, width: 176, height: 260, rotation: 0, imageRotation: 0 },
            { id: "2", x: 184, y: 108, width: 176, height: 260, rotation: 0, imageRotation: 0 },
            { id: "3", x: 368, y: 108, width: 175, height: 260, rotation: 0, imageRotation: 0 },
            { id: "4", x: 550, y: 108, width: 175, height: 260, rotation: 0, imageRotation: 0 },
            { id: "5", x: 733, y: 108, width: 175, height: 260, rotation: 0, imageRotation: 0 },
            { id: "6", x: 916, y: 108, width: 175, height: 260, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1099, y: 108, width: 175, height: 260, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-08",
    name: "LA 08 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 40, y: 30, width: 286, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 334, y: 30, width: 286, height: 412, rotation: 0, imageRotation: 0 },
            { id: "3", x: 627, y: 30, width: 286, height: 412, rotation: 0, imageRotation: 0 },
            { id: "4", x: 920, y: 30, width: 153, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 920, y: 241, width: 153, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 30, width: 155, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 241, width: 155, height: 203, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-09",
    name: "LA 09 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 60, y: 0, width: 168, height: 235, rotation: 0, imageRotation: 0 },
            { id: "2", x: 60, y: 242, width: 168, height: 234, rotation: 0, imageRotation: 0 },
            { id: "3", x: 236, y: 0, width: 167, height: 235, rotation: 0, imageRotation: 0 },
            { id: "4", x: 236, y: 242, width: 167, height: 234, rotation: 0, imageRotation: 0 },
            { id: "5", x: 410, y: 0, width: 167, height: 235, rotation: 0, imageRotation: 0 },
            { id: "6", x: 410, y: 242, width: 167, height: 234, rotation: 0, imageRotation: 0 },
            { id: "7", x: 765, y: 0, width: 366, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h0v7-10",
    name: "LA 10 - H0V7",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 174, y: 51, width: 277, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 748, y: 241, width: 134, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 748, y: 51, width: 134, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 890, y: 241, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 890, y: 51, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1030, y: 241, width: 133, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1030, y: 51, width: 133, height: 183, rotation: 0, imageRotation: 0 }
    ],
}
];